<div class="box-body">
    <div class="row" [formGroup]="patientNoteFG">
        <div class="col-lg-12 padding--right__7" formGroupName="Patient">
            <div class="mb-3">
                <textarea formControlName="Remarks" value="noteInfo?.Patient?.Remarks" class="w-98"></textarea>
            </div>
        </div>
    </div>
</div>
